export enum eVersionStatus {
    checking,
    true,
    false
}